import { Link } from 'react-router-dom';
import { siteSettings, externalLinks } from '@/mocks/siteSettings';

export default function Footer() {
  const logoUrl = 'https://storage.readdy-site.link/project_files/5b7aaa34-9bab-4986-a5b7-652c9dac38d9/d581acb6-9267-427a-b6c8-a5f1d0836255_compressed_LOGO_-1.webp';

  return (
    <footer className="relative overflow-hidden" style={{ backgroundColor: 'oklch(var(--secondary-950))' }} role="contentinfo">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{ opacity: 0.06, backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, oklch(var(--background-50)/0.3) 2px, oklch(var(--background-50)/0.3) 4px)' }} />

      <div className="relative w-full px-4 md:px-8 py-14 md:py-16">
        {/* Top ornamental line */}
        <div className="flex items-center justify-center gap-4 mb-12 opacity-30">
          <div className="h-px flex-1 max-w-[60px]" style={{ background: 'linear-gradient(to right, transparent, oklch(var(--background-400)/0.6))' }} />
          <span className="font-display italic text-xs" style={{ color: 'oklch(var(--background-400))' }}>&#10087;</span>
          <div className="h-px flex-1 max-w-[60px]" style={{ background: 'linear-gradient(to left, transparent, oklch(var(--background-400)/0.6))' }} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand — formal identity */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src={logoUrl}
                alt=""
                className="w-8 h-8 object-contain rounded-sm flex-shrink-0"
              />
              <span className="font-heading text-lg font-semibold text-background-50">
                {siteSettings.brandName}
                <span className="font-display italic font-normal ml-1.5 text-sm" style={{ color: 'oklch(var(--primary-400))' }}>
                  {siteSettings.brandNameEn}
                </span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-1">
              {siteSettings.companyName}
            </p>
            <p className="text-sm text-background-400 leading-relaxed mb-1">
              歷史、人文社科、公版經典與小說
            </p>
            <p className="text-sm text-background-400 leading-relaxed mb-1">
              <span className="text-background-500">官方網站</span>{' '}
              <span className="font-mono text-[13px]">fuko.sonbook.net</span>
            </p>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              本品牌委託崧博出版經銷，官方網站由崧博出版製作。
            </p>

            {/* Data & responsibility notes */}
            <div className="pt-4 mb-4" style={{ borderTop: '1px solid oklch(var(--background-400)/0.10)' }}>
              <p className="text-xs text-background-500 leading-relaxed mb-2.5">
                完整書名、作者、譯者、ISBN、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。
              </p>
              <p className="text-xs text-background-500 leading-relaxed mb-2.5">
                公版狀態可能因作品、版本、譯文、編輯內容、插圖、封面及使用地區而不同，實際權利資訊以個別作品與正式資料為準。
              </p>
              <p className="text-xs text-background-500 leading-relaxed">
                個別作品內容與作者觀點，不代表複刻文化或崧博出版的官方立場。
              </p>
            </div>

            <p className="text-xs text-background-500 font-serif italic">
              {siteSettings.copyright}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4 tracking-wider">網站導覽</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">品牌介紹</Link></li>
              <li><Link to="/stores" className="text-sm text-background-400 hover:text-background-100 transition-colors">合作購書通路</Link></li>
              <li><Link to="/faq" className="text-sm text-background-400 hover:text-background-100 transition-colors">常見問題</Link></li>
            </ul>
          </div>

          {/* Related Sites — three-site interconnection */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4 tracking-wider">相關網站</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://fuko.sonbook.net/"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors flex items-center gap-1.5"
                >
                  複刻文化官網
                  <span className="text-[11px] text-background-500 font-mono">fuko.sonbook.net</span>
                </a>
              </li>
              <li>
                <a
                  href={externalLinks.songbo}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors flex items-center gap-1.5"
                >
                  崧博出版主站<i className="ri-external-link-line text-[10px]"></i>
                </a>
              </li>
              <li>
                <a
                  href={externalLinks.catalog}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors flex items-center gap-1.5"
                >
                  崧博書籍資料庫<i className="ri-external-link-line text-[10px]"></i>
                </a>
              </li>
            </ul>
            <div className="mt-5 pt-4" style={{ borderTop: '1px solid oklch(var(--background-400)/0.10)' }}>
              <a
                href={externalLinks.songbo}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-background-400 hover:text-background-100 transition-colors flex items-center gap-1"
              >
                查看崧博出版與其他經銷品牌<i className="ri-external-link-line text-[10px]"></i>
              </a>
            </div>
            <div className="mt-6 font-serif italic">
              <p className="text-xs text-background-500">{siteSettings.email}</p>
            </div>
          </div>
        </div>

        {/* Bottom ornamental line */}
        <div className="flex items-center justify-center gap-4 mt-12 pt-8 opacity-25" style={{ borderTop: '1px solid oklch(var(--background-400)/0.15)' }}>
          <span className="font-display italic text-[10px]" style={{ color: 'oklch(var(--background-400))' }}>
            &ldquo;讓經典重新被閱讀&rdquo;
          </span>
        </div>
      </div>
    </footer>
  );
}